import { render, staticRenderFns } from "./lkuKoranrubrik.vue?vue&type=template&id=20ff18b3"
import script from "./lkuKoranrubrik.vue?vue&type=script&lang=js"
export * from "./lkuKoranrubrik.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranrubrik.vue?vue&type=style&index=0&id=20ff18b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports